import React from 'react';
const testimonials = [{
  initial: 'V',
  quote: 'Entro a cada sesión con un protocolo claro. Los padres empezaron a notar cambios desde la primera semana. Esto transformó mi práctica.',
  name: 'Valentina R.',
  role: 'Terapeuta Ocupacional · Buenos Aires'
}, {
  initial: 'M',
  quote: 'La gradación sensorial ya está pensada. Ya no me pregunto si estoy escalando bien. Mis sesiones fluyen de otra manera completamente.',
  name: 'Mariana L.',
  role: 'Psicopedagoga · Montevideo'
}, {
  initial: 'C',
  quote: 'Soy docente de apoyo y nunca pensé que podría aplicar herramientas clínicas en el aula. Con esta guía lo hago todos los días.',
  name: 'Camila F.',
  role: 'Docente de Apoyo · Santiago de Chile'
}];
export function TestimonialsSection() {
  return <section className="bg-white py-16 px-6" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <p className="font-display font-extrabold tracking-[0.18em] uppercase text-brand-green mb-3 text-[20px]" data-id="element-157">
          Lo que dicen nuestras colegas
        </p>
        <h2 className="font-display font-black text-3xl md:text-4xl uppercase mb-10 text-brand-ink" data-id="element-158">
          Resultados Reales,
          <br data-id="element-159" />
          Profesionales Reales
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-160">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-gray-200 rounded-md p-7" data-id="element-161">
              {/* Avatar */}
              <div className="w-[52px] h-[52px] rounded-full bg-gradient-to-br from-brand-green to-brand-green-dark flex items-center justify-center mb-4" data-id="element-162">
                <span className="te-display font-xt-white fontblack text-2xl" data-id="element-163">
                  {testimonial.initial}
                </span>
              </div>

              {/* Stars */}
              <div className="text-brand-yellow text-lg tracking-wider mb-3" data-id="element-164">
                ★★★★★
              </div>

              {/* Quote */}
              <p className="italic text-gray-700 text-sm leading-relaxed mb-4" data-id="element-165">
                "{testimonial.quote}"
              </p>

              {/* Name & Role */}
              <p className="font-display font-extrabold text-sm uppercase tracking-wider text-brand-ink" data-id="element-166">
                {testimonial.name}
              </p>
              <p className="text-xs text-brand-green font-semibold" data-id="element-167">
                {testimonial.role}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}